import type { RaceSummaryShellProps } from '@/modules/employer/pages/components/RaceSummaryShell/RaceSummaryShell.types'

import { RaceSummary } from '@/components/@Shared/UserManagmentCharts/RaceSummary/RaceSummary'

import { useEmployerStatsServiceEmployerStatsControllerGetRaceStats } from '@/__generated__/queries'

export function RaceSummaryShell({
  onUpdateChartsData,
}: RaceSummaryShellProps) {
  const { data, isFetching, isLoading } =
    useEmployerStatsServiceEmployerStatsControllerGetRaceStats()

  return (
    <RaceSummary
      data={data}
      isLoading={isLoading || isFetching}
      onUpdateChartsData={onUpdateChartsData}
    />
  )
}
